import i18n from "@service/locale/i18";
import {TicketEditFormSelectSources} from "@share/ticketSystem/components/types";
import {TicketType} from "@share/ticketSystem/enums/TicketTypes";
import {TicketService} from "@share/common/services/ticket/TicketService";

export const getTicketFormSelectSources = (): TicketEditFormSelectSources => {
    return {
        owner: [],
        responsibleUser: [],
        responsibleForImplementationUser: [],
        users: [],
        directions: [],
        categories: [],
        statuses: [],
        companies: [],
        branches: []
    }
}

export interface  TicketTableParams {
    ticketsType: TicketType;
    ticketService: TicketService;
    onlyOwn?: boolean;
}

export type TicketFormParams = TicketTableParams;

export const getRiskLevelSource = () => {
    return [
        {
            id: "riskLevelHigh",
            title: i18n.t("tickets.statistic.highRisks").toString()
        },
        {
            id: "riskLevelAcceptable",
            title: i18n.t("tickets.statistic.acceptableRisks").toString()
        },
        {
            id: "riskLevelUnacceptable",
            title: i18n.t("tickets.statistic.unacceptableRisks").toString()
        }
    ]
}

export const getRiskLevelSourceFull = () => {
    return [
        {
            id: "riskLevelHigh",
            title: i18n.t("tickets.statistic.highRisksDescription").toString()
        },
        {
            id: "riskLevelAcceptable",
            title: i18n.t("tickets.statistic.acceptableRisksDescription").toString()
        },
        {
            id: "riskLevelUnacceptable",
            title: i18n.t("tickets.statistic.unacceptableRisksDescription").toString()
        }
    ]
}